import { RootPaths } from "@src/appV2/App/paths";

export const ONBOARDING_STAGES = {
  INTERESTED_WORK_TYPE: "interestedWorkType",
  EMAIL: "agentEmail",
  NAME: "agentName",
  LICENSE: "agentLicense",
  ADDRESS: "agentAddress",
  PERSONAL_ID_VERIFICATION: "agentPersonalIdVerification",
  SSN: "agentSSN",
  STRIPE: "stripeOnboarding",
  READY_TO_EARN: "agentReadyToEarn",
  DOCUMENTS: "uploadDocuments",
  DOB: "agentDoB",
  CONTRACTOR_AGREEMENT_REVIEW: "contractorAgreementReview",
  AGREEMENT_EXPLANATION: "agreementExplanation",
  CONTRACTOR_AGREEMENT: "contractorAgreement",
  JOB_SEARCH_AGREEMENT: "jobSearchAgreement",
  QUALIFICATION: "agentQualification",
  CHECKR: "checkrInvite",
  FINAL: "final",
} as const;

export type OnboardingStage = (typeof ONBOARDING_STAGES)[keyof typeof ONBOARDING_STAGES];

const BASE_ONBOARDING_PATH = `${RootPaths.HOME}/onboarding`;

export const ONBOARDING_STAGES_PATHS = {
  EMAIL: `${BASE_ONBOARDING_PATH}/${ONBOARDING_STAGES.EMAIL}`,
  NAME: `${BASE_ONBOARDING_PATH}/${ONBOARDING_STAGES.NAME}`,
  ADDRESS: `${BASE_ONBOARDING_PATH}/${ONBOARDING_STAGES.ADDRESS}`,
  STRIPE: `${BASE_ONBOARDING_PATH}/${ONBOARDING_STAGES.STRIPE}`,
  PERSONAL_ID_VERIFICATION: `${BASE_ONBOARDING_PATH}/${ONBOARDING_STAGES.PERSONAL_ID_VERIFICATION}`,
  LICENSE: `${BASE_ONBOARDING_PATH}/${ONBOARDING_STAGES.LICENSE}`,
  INTERESTED_WORK_TYPE: `${BASE_ONBOARDING_PATH}/${ONBOARDING_STAGES.INTERESTED_WORK_TYPE}`,
  AGREEMENT_EXPLANATION: `${BASE_ONBOARDING_PATH}/${ONBOARDING_STAGES.AGREEMENT_EXPLANATION}`,
  CONTRACTOR_AGREEMENT: `${BASE_ONBOARDING_PATH}/${ONBOARDING_STAGES.CONTRACTOR_AGREEMENT}`,
  JOB_SEARCH_AGREEMENT: `${BASE_ONBOARDING_PATH}/${ONBOARDING_STAGES.JOB_SEARCH_AGREEMENT}`,
  FINAL: `${BASE_ONBOARDING_PATH}/${ONBOARDING_STAGES.FINAL}`,
} as const;
